import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API,
  //credentials: 'include',
  prepareHeaders: (headers) => {
    headers.set("Authorization", localStorage.getItem("token"))
    return headers
  }
})


export const tiendasApi = createApi({
  reducerPath: 'tiendasApi',
  baseQuery: baseQuery,
  keepUnusedDataFor: 20,
  endpoints: builder => ({}),
})
